import { ActivitySwing, Swing } from '@data';
import { queryClient } from '../config/client';
import { getActivitySwingsKey } from '../hooks/useActivitySwings';

/**
 * Update swing name/favorite status in swing activity list
 */
export const updateSwingNameInActivity = (activityId: number, update: Pick<Swing, 'uuid' | 'name' | 'favorite'>) => {
    const key = getActivitySwingsKey(activityId);
    const activitySwings: ActivitySwing[] | undefined = queryClient.getQueryData(key);
    if (!activitySwings?.length) {
        return;
    }

    const swingIndex = activitySwings.findIndex(({ uuid }) => uuid === update.uuid);
    if (swingIndex === -1) {
        return;
    }
    const swing = {
        ...activitySwings[swingIndex],
        ...update,
    };

    queryClient.setQueryData(key, [
        ...activitySwings.slice(0, swingIndex),
        swing,
        ...activitySwings.slice(swingIndex + 1),
    ]);
};
